export interface IcsSubscriptionI {
  id: string;
  calendarId: string | number;
  url: string;
  status: 'pending' | 'syncing' | 'active' | 'failed';
  lastSyncAt?: number;
  createdAt: number;
  error?: string;
}

export interface SubscriptionStateI {
  subscriptions: IcsSubscriptionI[];
  loading: boolean;
  error: string | null;
}

export const state: SubscriptionStateI = {
  subscriptions: [],
  loading: false,
  error: null,
};
